import { ConcreteEncodable } from "./ConcreteEncodable";

import { UserVisibilityRuleImplEncoder } from "../../encoder/UserVisibilityRuleImplEncoder";

import * as CubiqTS from "../../index";
import { UserVisibilityRule } from "../UserVisibilityRule";

export class UserVisibilityRuleImpl extends ConcreteEncodable implements UserVisibilityRule {
  public static enType: string = "com.bcdfx.model.UserVisibilityRuleImpl";

  /*FID=1*/
  public currencyPairs: Array<string> | null = null;
  /*FID=2*/
  public branches: Array<string> | null = null;
  /*FID=3*/
  public traderGroups: Array<CubiqTS.Long> | null = null;
  /*FID=4*/
  public salesGroups: Array<CubiqTS.Long> | null = null;
  /*FID=5*/
  public benchmarkFg: boolean;
  /*FID=6*/
  public limitFg: boolean;
  /*FID=7*/
  public algoFg: boolean;
  /*FID=8*/
  public myGroupsFg: boolean;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = UserVisibilityRuleImplEncoder.Instance;
    this.setEncodableType(UserVisibilityRuleImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "UserVisibilityRuleImpl[" +
      "currencyPairs=" +
      this.currencyPairs +
      "branches=" +
      this.branches +
      "traderGroups=" +
      this.traderGroups +
      "salesGroups=" +
      this.salesGroups +
      "benchmarkFg=" +
      this.benchmarkFg +
      "limitFg=" +
      this.limitFg +
      "algoFg=" +
      this.algoFg +
      "myGroupsFg=" +
      this.myGroupsFg +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
